const hexCodeRegex = /^#([0-9A-F]{3}){1,2}$/i;

export const validateHexColor = (value) =>
  hexCodeRegex.test(value) ? value : '';

export default validateHexColor;
